import Vue from 'vue';
export default {
  data() {
    return { dataGetPatientById: {} };
  },
  methods: {
    getPatientFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getPatientWithDetail', id).then(() => {
        if (this.$store.state.patientModule.successFlag) {
          let temp = this.$store.state.patientModule.patient;
          this.transformPatientInfo(temp);
          if (temp.patientParturitionDetail) {
            //زایمان
            if (temp.patientParturitionDetail.beforeCodeArrival == true) {
              temp.patientParturitionDetail.beforeCodeArrival = 'قبل از رسیدن کد';
            } else if (temp.patientParturitionDetail.beforeCodeArrival == false) {
              temp.patientParturitionDetail.beforeCodeArrival = 'بعد از رسیدن کد';
            } else {
              temp.patientParturitionDetail.beforeCodeArrival = '-';
            }
            if (temp.patientParturitionDetail.isMultiple == true) {
              temp.patientParturitionDetail.isMultiple = 'دارد';
            } else if (temp.patientParturitionDetail.isMultiple == false) {
              temp.patientParturitionDetail.isMultiple = 'ندارد';
            } else {
              temp.patientParturitionDetail.isMultiple = '-';
            }
            if (temp.patientParturitionDetail.hasParturitionDone == true) {
              temp.patientParturitionDetail.hasParturitionDone = 'بله';
            } else if (temp.patientParturitionDetail.hasParturitionDone == false) {
              temp.patientParturitionDetail.hasParturitionDone = 'خیر';
            } else {
              temp.patientParturitionDetail.hasParturitionDone = '-';
            }

            // if (temp.patientParturitionDetail.parturitionDate) {
            //   temp.patientParturitionDetail.parturitionDate = Vue.moment(
            //     temp.patientParturitionDetail.parturitionDate,
            //   ).format('HH:mm:ss jYYYY/jM/jD');
            // }
          }
          if (temp.patientVitalSigns.length > 0) {
            //علائم حیاتی
            for (let i = 0; i < temp.patientVitalSigns.length; i++) {
              if (temp.patientVitalSigns[i].observationDate) {
                temp.patientVitalSigns[i].observationDate = Vue.moment(
                  temp.patientVitalSigns[i].observationDate,
                ).format('HH:mm');
              }
            }
          }
          if (temp.patientBodyExaminations.length > 0) {
            // temp.patientBodyExaminations
            //   .forEach
            // (c) => (c.color = this.getRandomRolor())
            // ();
            for (let i = 0; i < temp.patientBodyExaminations.length; i++) {
              //   this.setAdamakColor(temp.patientBodyExaminations[i]);
            }
          }
          if (!temp.patientPupilExamination) {
            temp.patientPupilExamination = {
              rightNormal: false,
              eftNormal: false,
              rightDilate: false,
              leftDilate: false,
              rightMiotic: false,
              leftMiotic: false,
              rightNoAnswer: false,
              leftNoAnswer: false,
            };
          }
          if (!temp.patientRespiratorySoundDetail) {
            temp.patientRespiratorySoundDetail = {
              rightFineRale: false,
              leftFineRale: false,
              rightCoarseRale: false,
              leftCoarseRale: false,
              rightWheeze: false,
              leftWheeze: false,
              rightSoundReduction: false,
              leftSoundReduction: false,
            };
          }
          if (temp.patientDetails.length) {
            let typeOfEmergency =
              temp.patientDetails[0].typeOfEmergency && temp.patientDetails[0].typeOfEmergency.title
                ? temp.patientDetails[0].typeOfEmergency.title
                : '-';
            temp.typeOfEmergency = typeOfEmergency;
            temp.diagnosis = temp.patientDetails[0].diagnosis;
            temp.dianosisDetail = temp.patientDetails[0].dianosisDetail;
          }
          if (temp.patientAbdominalExamination == null) {
            temp.patientAbdominalExamination = [];
          }
          //علائم همراه
          if (temp.patientAccompanyingSymptoms.length > 0) {
            temp.patientAccompanyingSymptoms.forEach((c) => (c.hasDetail = false));
            temp.patientAccompanyingSymptoms.forEach((c) => (c.showDetail = false));
            for (let i = 0; i < temp.patientAccompanyingSymptoms.length; i++) {
              if (temp.patientAccompanyingSymptoms[i].title == 'علائم BE FAST') {
                temp.patientAccompanyingSymptoms[i].hasDetail = true;
                temp.patientAccompanyingSymptoms[i].showDetail = false;
                temp.patientAccompanyingSymptoms[i].insideItems = [];
                let imbalance = '-';
                let visionChanges = '-';
                let saggingFace = '-';
                let paralysis = '-';
                let talkingProblem = '-';
                if (temp.patientAccompanyingSymptoms[i].patientBeFastDetail != null) {
                  if (temp.patientAccompanyingSymptoms[i].patientBeFastDetail.imbalance == false) {
                    imbalance = 'خیر';
                  } else if (
                    temp.patientAccompanyingSymptoms[i].patientBeFastDetail.imbalance == true
                  ) {
                    imbalance = 'بله';
                  }
                  if (
                    temp.patientAccompanyingSymptoms[i].patientBeFastDetail.visionChanges == false
                  ) {
                    visionChanges = 'خیر';
                  } else if (
                    temp.patientAccompanyingSymptoms[i].patientBeFastDetail.visionChanges == true
                  ) {
                    visionChanges = 'بله';
                  }
                  if (
                    temp.patientAccompanyingSymptoms[i].patientBeFastDetail.saggingFace == false
                  ) {
                    saggingFace = 'خیر';
                  } else if (
                    temp.patientAccompanyingSymptoms[i].patientBeFastDetail.saggingFace == true
                  ) {
                    saggingFace = 'بله';
                  }
                  if (temp.patientAccompanyingSymptoms[i].patientBeFastDetail.paralysis == false) {
                    paralysis = 'خیر';
                  } else if (
                    temp.patientAccompanyingSymptoms[i].patientBeFastDetail.paralysis == true
                  ) {
                    paralysis = 'ّبله';
                  }
                  if (
                    temp.patientAccompanyingSymptoms[i].patientBeFastDetail.talkingProblem == false
                  ) {
                    talkingProblem = 'خیر';
                  } else if (
                    temp.patientAccompanyingSymptoms[i].patientBeFastDetail.talkingProblem == true
                  ) {
                    talkingProblem = 'ّبله';
                  }
                }
                temp.patientAccompanyingSymptoms[i].insideItems.push(
                  { title: 'عدم تعادل:', value: imbalance, id: 1 },
                  { title: 'تغییرات بینایی:', value: visionChanges, id: 2 },
                  { title: 'افتادگی صورت:', value: saggingFace, id: 3 },
                  { title: 'ضعف یا فلج اندام ها:', value: paralysis, id: 4 },
                  { title: 'اشکال در صحبت کردن:', value: talkingProblem, id: 5 },
                );
              }
              if (temp.patientAccompanyingSymptoms[i].title == 'تنگی نفس') {
                temp.patientAccompanyingSymptoms[i].hasDetail = true;
                temp.patientAccompanyingSymptoms[i].showDetail = false;
                temp.patientAccompanyingSymptoms[i].insideItems = [];
                let hasActivityBreathProblem = '-';
                if (temp.patientAccompanyingSymptoms[i].patientRespiratoryDetail != null) {
                  if (
                    temp.patientAccompanyingSymptoms[i].patientRespiratoryDetail
                      .hasActivityBreathProblem == false
                  ) {
                    hasActivityBreathProblem = 'خیر';
                  } else if (
                    temp.patientAccompanyingSymptoms[i].patientRespiratoryDetail
                      .hasActivityBreathProblem == true
                  ) {
                    hasActivityBreathProblem = 'بله';
                  }
                }
                temp.patientAccompanyingSymptoms[i].insideItems.push({
                  title: 'عدم تعادل:',
                  value: hasActivityBreathProblem,
                  id: 1,
                });
              }
              if (temp.patientAccompanyingSymptoms[i].title == 'سردرد') {
                temp.patientAccompanyingSymptoms[i].hasDetail = true;
                temp.patientAccompanyingSymptoms[i].showDetail = false;
                temp.patientAccompanyingSymptoms[i].insideItems = [];
                let headacheType = '-';
                let headacheLocation = '-';
                let headacheOtherSign = '-';
                if (temp.patientAccompanyingSymptoms[i].patientHeadacheDetail != null) {
                  if (temp.patientAccompanyingSymptoms[i].patientHeadacheDetail.headacheType) {
                    headacheType =
                      temp.patientAccompanyingSymptoms[i].patientHeadacheDetail.headacheType.title;
                  }
                  if (temp.patientAccompanyingSymptoms[i].patientHeadacheDetail.headacheLocation) {
                    headacheLocation =
                      temp.patientAccompanyingSymptoms[i].patientHeadacheDetail.headacheLocation
                        .title;
                  }
                  if (temp.patientAccompanyingSymptoms[i].patientHeadacheDetail.headacheOtherSign) {
                    headacheOtherSign =
                      temp.patientAccompanyingSymptoms[i].patientHeadacheDetail.headacheOtherSign
                        .title;
                  }
                }
                temp.patientAccompanyingSymptoms[i].insideItems.push(
                  { title: 'نوع سردرد:', value: headacheType, id: 1 },
                  { title: 'محل سردرد:', value: headacheLocation, id: 2 },
                  { title: 'علائم همراه:', value: headacheOtherSign, id: 3 },
                );
                for (
                  let j = 0;
                  j <
                  temp.patientAccompanyingSymptoms[i].patientHeadacheOtherSpecificationDetails
                    .length;
                  j++
                ) {
                  let title =
                    temp.patientAccompanyingSymptoms[i].patientHeadacheOtherSpecificationDetails
                      .headacheOtherSpecification &&
                      temp.patientAccompanyingSymptoms[i].patientHeadacheOtherSpecificationDetails
                        .headacheOtherSpecification.title
                      ? temp.patientAccompanyingSymptoms[i].patientHeadacheOtherSpecificationDetails
                        .headacheOtherSpecification.title
                      : '-';
                  temp.patientAccompanyingSymptoms[i].insideItems.push({
                    title: title,
                    value: '',
                    id: j + 4,
                  });
                }
                for (
                  let j = 0;
                  j < temp.patientAccompanyingSymptoms[i].patientHeadacheIllnessHistories.length;
                  j++
                ) {
                  let title =
                    temp.patientAccompanyingSymptoms[i].patientHeadacheIllnessHistories
                      .headacheIllnessHistory &&
                      temp.patientAccompanyingSymptoms[i].patientHeadacheIllnessHistories
                        .headacheIllnessHistory.title
                      ? temp.patientAccompanyingSymptoms[i].patientHeadacheIllnessHistories
                        .headacheIllnessHistory.title
                      : '-';
                  temp.patientAccompanyingSymptoms[i].insideItems.push({
                    title: title,
                    value: '',
                    id: temp.patientAccompanyingSymptoms[i].insideItems.length + 1,
                  });
                }
              }
              if (temp.patientAccompanyingSymptoms[i].title == 'سرگیجه') {
                temp.patientAccompanyingSymptoms[i].hasDetail = true;
                temp.patientAccompanyingSymptoms[i].showDetail = false;
                temp.patientAccompanyingSymptoms[i].insideItems = [];
                let vertigoType = '-';
                let vertigoDuration = '-';
                let vertigoAggravatingFactor = '-';
                if (temp.patientAccompanyingSymptoms[i].patientVertigoDetail != null) {
                  if (temp.patientAccompanyingSymptoms[i].patientVertigoDetail.vertigoType) {
                    vertigoType =
                      temp.patientAccompanyingSymptoms[i].patientVertigoDetail.vertigoType.title;
                  }
                  if (temp.patientAccompanyingSymptoms[i].patientVertigoDetail.vertigoDuration) {
                    vertigoDuration =
                      temp.patientAccompanyingSymptoms[i].patientVertigoDetail.vertigoDuration
                        .title;
                  }
                  if (
                    temp.patientAccompanyingSymptoms[i].patientVertigoDetail
                      .vertigoAggravatingFactor
                  ) {
                    vertigoAggravatingFactor =
                      temp.patientAccompanyingSymptoms[i].patientVertigoDetail
                        .vertigoAggravatingFactor.title;
                  }
                }
                temp.patientAccompanyingSymptoms[i].insideItems.push(
                  { title: 'نوع سرگیجه:', value: vertigoType, id: 1 },
                  {
                    title: 'مدت هر حمله سرگیجه:',
                    value: vertigoDuration,
                    id: 2,
                  },
                  {
                    title: 'عامل تشدید کننده:',
                    value: vertigoAggravatingFactor,
                    id: 3,
                  },
                );
                for (
                  let j = 0;
                  j < temp.patientAccompanyingSymptoms[i].patientVertigoOtherSpecifications.length;
                  j++
                ) {
                  let title =
                    temp.patientAccompanyingSymptoms[i].patientVertigoOtherSpecifications
                      .vertigoOtherSpecification &&
                      temp.patientAccompanyingSymptoms[i].patientVertigoOtherSpecifications
                        .vertigoOtherSpecification.title
                      ? temp.patientAccompanyingSymptoms[i].patientVertigoOtherSpecifications
                        .vertigoOtherSpecification.title
                      : '-';
                  temp.patientAccompanyingSymptoms[i].insideItems.push({
                    title: title,
                    value: '',
                    id: j + 4,
                  });
                }
              }
              if (temp.patientAccompanyingSymptoms[i].title == 'درد قفسه سینه') {
                temp.patientAccompanyingSymptoms[i].hasDetail = true;
                temp.patientAccompanyingSymptoms[i].showDetail = false;
                temp.patientAccompanyingSymptoms[i].insideItems = [];
                let chestPainType = '-';
                let chestPainDuration = '-';
                let chestPainLocation = '-';
                let chestPainPropagation = '-';
                let isActivityPain = '-';
                if (temp.patientAccompanyingSymptoms[i].patientChestPainDetail != null) {
                  if (temp.patientAccompanyingSymptoms[i].patientChestPainDetail.chestPainType) {
                    chestPainType =
                      temp.patientAccompanyingSymptoms[i].patientChestPainDetail.chestPainType
                        .title;
                  }
                  if (
                    temp.patientAccompanyingSymptoms[i].patientChestPainDetail.chestPainDuration
                  ) {
                    chestPainDuration =
                      temp.patientAccompanyingSymptoms[i].patientChestPainDetail.chestPainDuration
                        .title;
                  }
                  if (
                    temp.patientAccompanyingSymptoms[i].patientChestPainDetail.chestPainLocation
                  ) {
                    chestPainLocation =
                      temp.patientAccompanyingSymptoms[i].patientChestPainDetail.chestPainLocation
                        .title;
                  }
                  if (
                    temp.patientAccompanyingSymptoms[i].patientChestPainDetail.chestPainPropagation
                  ) {
                    chestPainPropagation =
                      temp.patientAccompanyingSymptoms[i].patientChestPainDetail
                        .chestPainPropagation.title;
                  }
                  if (
                    temp.patientAccompanyingSymptoms[i].patientChestPainDetail.isActivityPain ==
                    false
                  ) {
                    isActivityPain = 'خیر';
                  } else if (
                    temp.patientAccompanyingSymptoms[i].patientChestPainDetail.isActivityPain ==
                    true
                  ) {
                    isActivityPain = 'ّبله';
                  }
                  temp.patientAccompanyingSymptoms[i].insideItems.push(
                    { title: 'درد فعالیتی:', value: isActivityPain, id: 1 },
                    { title: 'نوع درد:', value: chestPainType, id: 2 },
                    { title: 'محل درد:', value: chestPainLocation, id: 3 },
                    {
                      title: 'انتشار درد:',
                      value: chestPainPropagation,
                      id: 4,
                    },
                    { title: 'مدت:', value: chestPainDuration, id: 5 },
                    {
                      title: 'نمره درد:',
                      value: temp.patientAccompanyingSymptoms[i].patientChestPainDetail.painScale,
                      id: 6,
                    },
                  );
                }
              }
            }
          }
          this.patientInfo = temp;
          this.getPatientDoctorDetailActiveInfoFunction(id, this.missionPhoneId);
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getPatientFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getPatientByIdFunction: function (id) {
      this.dataGetPatientById = {};
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getPatientById', id).then(() => {
        if (this.$store.state.patientModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.patientModule.patientSimpleData;
          this.dataGetPatientById = temp;
          try {
            this.$root.$refs.FollowUpPatient.patientAge = temp?.yearOfAge;
            this.$root.$refs.FollowUpPatient.patientMonth = temp?.monthOfAge;
          } catch (error) {
            console.log("A error : ", error);
          }
          if (this.$route.name == 'followUpPatiant') {
            if (temp) {
              this.setData(temp);
            }
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getPatientByIdFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    addPatientFunction: function (data) {
      if (!this.load.val) {
        this.load.val = true;
      }
      if (data.gender == '') {
        data.gender = null;
      }
      if (data.arriveToPatientTime == '') {
        data.arriveToPatientTime = null;
      }
      if (data.dateOfOnset == '') {
        data.dateOfOnset = null;
      }
      this.$store.dispatch('addPatient', data).then(() => {
        if (this.$store.state.patientModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.patientModule.addPatient;
          if (this.$route.name == 'followUpPatiant') {
            this.patientAdded(temp);
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addPatientFunction(data);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deleteCityFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deleteCity', this.cityId).then(() => {
        if (this.$store.state.cityModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllCitys();
          this.snackText = ' شهرستان با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.cityModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteCityFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deletePatientFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deletePatient', id).then(() => {
        if (this.$store.state.patientModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          this.getMissionDataByfollowUpFunction(Number(this.missionPhoneId));
          this.snackText = ' مددجو با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deletePatientFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getPatientAttachmentFunction: function (patientId) {
      if (!this.load.val) {
        this.load.val == true;
      }
      this.$store.dispatch('getPatientAttachment', patientId).then(() => {
        if (this.$store.state.patientModule.successFlag) {
          let temp = this.$store.state.patientModule.attachment;
          this.loadAttachmentData(temp);
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getPatientAttachmentFunction(patientId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.patientModule.error;
      if (this.$refs.snackRef) {
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
      } else {
        this.showErrorAlert(this.snackText);
      }
    },
  },
};
